import base from "@/store/utils/api-route/base";

const api = {
	listHistory: `${base.masterData}whatsapp/blast/list_history_blast`,
	countTemplate: `${base.masterData}whatsapp/blast/get_total_message_template`,
	listDeviceTiny: `${base.masterData}whatsapp/list_perangkat_wa_tiny`,
	detailHistory: `${base.masterData}whatsapp/blast/detail_history_blast`,
	listMessageInDetailHistory: `${base.masterData}whatsapp/blast/list_message_blast_in_detail`,
	detailTemplate: `${base.masterData}whatsapp/blast/detail_message_template`,
	listTemplate: `${base.masterData}whatsapp/blast/list_message_template`,
	deleteTemplate: `${base.masterData}whatsapp/blast/delete_message_template`,
	createBlast: `${base.masterData}whatsapp/blast/create_blast`,
	listCustomer: `${base.masterData}whatsapp/blast/list_blast_customer`,
	createTemplateBlast: `${base.masterData}whatsapp/blast/create_message_template`,
	updateTemplateBlast: `${base.masterData}whatsapp/blast/update_message_template`,

	startBlast: `${base.masterData}whatsapp/blast/start_blast`,
	pauseBlast: `${base.masterData}whatsapp/blast/pause_blast`,
	cancelBlast: `${base.masterData}whatsapp/blast/cancel_blast`,

	resendPerBlast: `${base.masterData}whatsapp/blast/resend_failed_message_per_blast`,
	resendPerId: `${base.masterData}whatsapp/blast/resend_failed_message_per_id`,
};

export default api;